
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/historical",
      function () {
        return require("private-next-pages/docs/historical/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/historical"])
      });
    }
  